import { baseBCGet } from '../base/baseBC';

const str = '';

export const apartmentPeopleModelGet = ({ buildingId = '', apartmentId = '', }) => {
    return {
        apartmentId: apartmentId,
        peopleTypeId: str,
        email: str,
        firstName: str,
        lastName: str,
        phoneNumber: str,
        ...baseBCGet({ buildingId: buildingId, }),
    };
};